































import { computed, defineComponent, ref, watch } from '@nuxtjs/composition-api';
import useVehiclesSidebar from '@shared/composables/useVehiclesSidebar';
import { VehicleSidebarState } from '@shared/system-constants';
import { UCButtonGroup } from '@shared/ui';
import { PartsDbVehicleSummary } from '@unified-commerce/gpc-vue-storefront-parts-db';

import AMXButton from '~/components/AMXButton.vue';
import SearchResults from '~/components/VehiclesSideBar/SearchResults.vue';
import SidebarHeading from '~/components/VehiclesSideBar/SidebarHeading.vue';
import SidebarSubheading from '~/components/VehiclesSideBar/SidebarSubheading.vue';
import useVirtualVehicle from '~/composables/useVirtualVehicle';

import NoResultsFound from '../NoResultsFound.vue';
import RegoSearchLookup from './RegoSearchLookup.vue';

enum ViewState {
  SEARCH,
  RESULTS,
}

export default defineComponent({
  name: 'VehiclesRegoSearch',
  components: {
    UCButtonGroup,
    SidebarSubheading,
    NoResultsFound,
    SearchResults,
    AMXButton,
    SidebarHeading,
    RegoSearchLookup,
  },
  setup() {
    const viewState = ref<ViewState>(ViewState.SEARCH);
    const { setView, close: closeSideBar } = useVehiclesSidebar();

    const inputYear = ref<number | undefined>(undefined);
    const searchError = ref('');

    const regoSearchFormValues = ref({
      vehicles: [] as PartsDbVehicleSummary[],
      exactYear: '',
    });

    const vehicles = computed(() => regoSearchFormValues.value.vehicles);
    const exactYear = computed(() => regoSearchFormValues.value.exactYear);

    const { virtualVehicles, loading, noResults } = useVirtualVehicle({
      vehicles,
      exactYear,
    });

    watch(virtualVehicles, () => {
      if (virtualVehicles.value.length > 0) {
        viewState.value = ViewState.RESULTS;
      }
    });

    const onSearchAgainClicked = () => {
      viewState.value = ViewState.SEARCH;
      inputYear.value = undefined;
    };

    const onVINSearchClicked = () => setView(VehicleSidebarState.VIN_SEARCH);

    const onManualSearchClicked = () => setView(VehicleSidebarState.MANUAL_SEARCH);

    return {
      loading,
      searchError,
      viewState,
      ViewState,
      onManualSearchClicked,
      onVINSearchClicked,
      onSearchAgainClicked,
      inputYear,
      noResults,
      virtualVehicles,
      regoSearchFormValues,
      closeSideBar,
    };
  },
});
